import React from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import localforage from 'localforage';
import { useAppSelector } from 'src/hooks/useStore';
import { selectCurrentUser } from 'src/store/storeUtils';
import { PortalConfigContext } from 'src/context';

export const useCompanySwitcherVisibility = (): {
  visibility: 'mobile' | 'desktop' | 'hidden';
} => {
  const [hasMultipleCompanies, setHasMultipleCompanies] = React.useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const portalConfig = React.useContext(PortalConfigContext);
  const companiesEnabled = !portalConfig.features.disableCompanies;
  const currentUser = useAppSelector(selectCurrentUser);
  const isClient = useAppSelector((state) => state.user.isClient);

  React.useEffect(() => {
    if (isClient) {
      (async () => {
        // The localforage implementation is here so we don't have
        // to wait for the network calls that this component depends on.
        const cachedHasMultipleCompanies = await localforage.getItem(
          'companySwitcher.hasMultipleCompanies',
        );
        if (typeof cachedHasMultipleCompanies === 'boolean') {
          setHasMultipleCompanies(cachedHasMultipleCompanies);
        }
      })();
    }
  }, []);

  React.useEffect(() => {
    if (currentUser && isClient) {
      const hasMultipleCompaniesValue =
        (currentUser?.fields.companyIds?.length ?? 0) > 1;
      localforage.setItem(
        'companySwitcher.hasMultipleCompanies',
        hasMultipleCompaniesValue,
      );
      setHasMultipleCompanies(hasMultipleCompaniesValue);
    }
  }, [currentUser]);

  const isVisible = hasMultipleCompanies && isClient && companiesEnabled;
  if (isVisible) {
    return {
      visibility: isMobile ? 'mobile' : 'desktop',
    };
  }

  return {
    visibility: 'hidden',
  };
};
